const AUTH_CODE_LENGTH = 4;

export { AUTH_CODE_LENGTH };
